import { Company } from '@app/core/model/company.model'
import { Type } from 'class-transformer'

export class RatecardIdentity {
  id!: number
  name!: string
  currentVersionNumber!: number
  trafficImported!: boolean
  costPlus!: boolean
  archived: boolean
  scopeMarkCard: boolean
  companyId!: number
  externalType?: any
  defaultCard?: boolean
  @Type(() => Date) updatedTs?: Date
  @Type(() => Company) company?: Company
}
